
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/the-team",
      function () {
        return require("private-next-pages/the-team.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/the-team"])
      });
    }
  